"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const destroyFns = [];
var _default = destroyFns;
exports.default = _default;